import base from '../dr-base'
import drLogin from './dr-login.vue'
import { listOfLoginMethods } from './listOfLoginMethods'

const schema = {
  $Type: 'dr-login',
  name: 'Login',
  group: 'Common widgets',
  icon: 'sign-in',
  ...base,
  properties: {
    ...base.properties,
    Caption: {
      name: 'vuetifyWidgets.dr-login.caption',
      type: 'string',
      default: 'Caption'
    },
    Description: {
      name: 'vuetifyWidgets.dr-login.description',
      type: 'string',
      default: 'Description'
    },
    ForgotPasswordCaption: {
      name: 'vuetifyWidgets.dr-login.forgotPasswordCaption',
      type: 'string',
      default: 'Forgot password?'
    },
    ForgotPasswordUrl: {
      name: 'vuetifyWidgets.dr-login.forgotPasswordUrl',
      type: 'string',
      default: ''
    },
    DefaultLoginMethod: {
      name: 'Дэфолтный метод логина',
      type: 'string',
      computed(params) {
        return listOfLoginMethods(params.that)
      },
      enum: []
    },
    DisabledLoginMethods: {
      name: 'Отключеннёе способы входа',
      type: 'multiple-select',
      computed(that) {
        return listOfLoginMethods(that)
      },
      selectedItems: []
    },
    AlternativeLogin: {
      name: 'vuetifyWidgets.dr-login.alternativeLogin',
      type: 'string',
      enum: [{
        value: '',
        text: 'vuetifyWidgets.dr-login.doNotUse'
      }, {
        value: 'qr',
        text: 'vuetifyWidgets.dr-login.QRCode'
      }],
      default: ''
    }
  }
}

export default {
  schema,
  component: drLogin
}